import * as yup from 'yup';

import { Domicile, AccreditedStatus } from '@arrived/models';

export const suitabilityQuestionnaireSchema = yup.object({
  netWorthOver1m: yup.boolean().required(),
  individualIncomeOver200k: yup.boolean().required(),
  jointIncomeOver300k: yup.boolean().required(),
  organizationAssetsOver5m: yup.boolean().when('$isIndividualAccountType', {
    is: true,
    then: (schema) => schema.strip(),
    otherwise: (schema) => schema.required(),
  }),
  associatedWithFinra: yup.boolean().required(),
  finraInstitutionName: yup
    .string()
    .trim()
    .when('associatedWithFinra', {
      is: true,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.notRequired().nullable().strip(),
    }),
  associatedWithPublicCompany: yup.boolean().required(),
  publicCompanyTickers: yup
    .string()
    .trim()
    .when('associatedWithPublicCompany', {
      is: true,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.notRequired().nullable().strip(),
    }),
});

export type SuitabilityQuestionnaireSchema = yup.InferType<typeof suitabilityQuestionnaireSchema>;

export const getIsAccreditedInvestor = (
  suitabilityQuestionnaire?: Partial<SuitabilityQuestionnaireSchema>
): boolean => {
  const { netWorthOver1m, individualIncomeOver200k, jointIncomeOver300k, organizationAssetsOver5m } =
    suitabilityQuestionnaire || {};

  return Boolean(netWorthOver1m || individualIncomeOver200k || jointIncomeOver300k || organizationAssetsOver5m);
};

// TODO: Move to common
export const domicileToResidentTypeString = (domicile: Domicile = Domicile.NONE): string => {
  switch (domicile) {
    case Domicile.US_CITIZEN:
    case Domicile.US_RESIDENT:
      return 'Domestic Account';

    case Domicile.NON_RESIDENT:
      return 'International Account';

    case Domicile.NONE:
    default:
      return 'N/A';
  }
};

export const getAccreditedStatus = (accreditedInvestor?: boolean): AccreditedStatus => {
  if (typeof accreditedInvestor === 'undefined') {
    return AccreditedStatus.PENDING;
  }

  return accreditedInvestor ? AccreditedStatus.SELF_ACCREDITED : AccreditedStatus.NOT_ACCREDITED;
};
